<p-toast [baseZIndex]="1000" position="top-left"></p-toast>
<div class="container-fluid">
  <div class="card-panel mt-5 mb-5">
    <div class="row">
      <div class="col-md-5">
        <lib-page-header-light page-title="PROCESSOS LICITATÓRIOS" fa-icon="clipboard-list"></lib-page-header-light>
      </div>
      <div class="col-md-7">
        <button type="button" (click)="sair()" class="btn btn-sm btn-outline-secondary float-right  ml-5">
          <img src="assets/img/global/cross.png" alt="sair" title="Sair" height="20" width="20">
        </button>
        <lib-export-list (acao)="exportarListagem($event)"></lib-export-list>
        <a *ngIf="podeIncluir()" [routerLink]="['/licitacoes', 'novo']"
          class="btn btn-outline-success btn-sm float-right mr-2">
          <img src="assets/img/global/plus.png" alt="novo" class="mr-2" title="Incluir" height="20" width="20">Novo
        </a>
      </div>
    </div>
    <hr class="mt-2 mb-4" />
    <div class="row">
      <div class="col-md-4">
        <lib-filtro [(filtro)]="filtro" (localizaClick)="onClick($event)" (localizaKeydown)="onClick($event)">
        </lib-filtro>
      </div>
    </div>
    <div class="row" *ngIf="lista && lista.length === 0">
      <div class="col-12">
        <em class="fa fa-exclamation-triangle text-black-50" style="font-size: 20px"></em>
        <span class="text-black-50 ml-1">Não foram encontrados registros cadastrados!</span>
      </div>
    </div>
    <div class="row" *ngIf="lista && lista.length > 0">
      <div class="col-md">
        <div class="table-responsive">
          <table class="table table-eddy">
            <thead>
              <tr>
                <th scope="col" class="text-center">Licitação/Processo</th>
                <th scope="col" class="text-center">Modalidade/Situação</th>
                <th scope="col" class="d-sm-none d-md-none d-lg-none d-xl-block">Objeto</th>
                <th scope="col" class="text-center" style="width: 180px;">Datas</th>
                <th scope="col" class="text-center" style="width: 172px;">Valores</th>
                <th scope="col" style="width: 60px;"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of lista">
                <td class="text-center">
                  <span class="d-block font-weight-bold">{{item.numero | LICITACAO}}</span>
                  <span class="d-block mt-2">{{item.processo | LICITACAO}}</span>
                </td>
                <td class="text-center">
                  <span class="d-block">{{item.modalidade.nome}}</span>
                  <span class="d-block mt-2">{{item.situacao}}</span>
                </td>
                <td class="d-sm-none d-md-none d-lg-none d-xl-block">
                  <span class="word-break-all">{{funcaoService.abreviarStr(item.objeto, 200, true)}}</span>
                </td>
                <td>
                  <div class="row" *ngIf="item.data_abertura">
                    <span class="col-7">Abertura: </span>
                    <span class="text-right col-5">{{item.data_abertura | date:'dd/MM/yy':'GMT'}}</span>
                  </div>
                  <div class="row" *ngIf="item.data_edital">
                    <span class="col-7">Edital: </span>
                    <span class="text-right col-5">{{item.data_edital | date:'dd/MM/yy':'GMT'}}</span>
                  </div>
                  <div class="row" *ngIf="item.data_julgamento">
                    <span class="col-7">Julgamento: </span>
                    <span class="text-right col-5">{{item.data_julgamento | date:'dd/MM/yy':'GMT'}}</span>
                  </div>
                  <div class="row" *ngIf="item.data_parecer">
                    <span class="col-7">Parecer: </span>
                    <span class="text-right col-5">{{item.data_parecer | date:'dd/MM/yy':'GMT'}}</span>
                  </div>
                  <div class="row" *ngIf="item.data_homologacao">
                    <span class="col-7">Homologação: </span>
                    <span class="text-right col-5">{{item.data_homologacao | date:'dd/MM/yy':'GMT'}}</span>
                  </div>
                </td>
                <td>
                  <div class="row">
                    <span class="col-4">Estimado: </span>
                    <span class="text-right col-8">{{item.valor_estimado | number:'1.2-2'}}</span>
                  </div>
                  <div class="row">
                    <span class="col-4">Licitado: </span>
                    <span class="text-right col-8">{{item.valor_licitado | number:'1.2-2'}}</span>
                  </div>
                </td>
                <td class="text-right">
                  <button [routerLink]="['/licitacoes', item.id, 'visualizar']" routerLinkActive="router-link-active"
                    *ngIf="!podeIncluir()" class="btn btn-sm btn-outline-secondary mr-2 float-right">
                    <img src="assets/img/global/zoom.png" alt="visualizar" height="18" width="18">
                  </button>
                  <button [routerLink]="['/licitacoes', item.id, 'editar']" routerLinkActive="router-link-active"
                    *ngIf="podeIncluir()" class="btn btn-sm btn-outline-primary mr-2">
                    <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="row float-right" *ngIf="lista && lista.length > 0">
      <div class="col-12 mb-5">
        <lib-paginacao [(paginaCorrente)]="paginaCorrente" [(paginaTotal)]="paginaTotal"
          (paginaAnterior)="paginaAnterior()" (proximaPagina)="proximaPagina()"></lib-paginacao>
      </div>
    </div>
    <br>
    <br>
  </div>
</div>